import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Award } from 'lucide-react';
import InfoPanel from './InfoPanel';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { API_BASE } from '../../config/api';

const API = `${API_BASE}/api`;

export default function ProgrammeRubricScore({ programmeId, token, refreshKey, open, onToggle, onEmpty }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/programmes/${programmeId}/my-rubric-score`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [programmeId, token, refreshKey]);

  if (!data?.approved) return onEmpty || null;
  const pct = Math.min(100, (data.total_score / data.total_points) * 100);
  return (
    <InfoPanel testId="learner-rubric-score" title="Assessment score" icon={Award} open={open} onToggle={onToggle}
      aside={<Badge data-testid="learner-rubric-pass-status" className={data.passed ? 'bg-green-500/15 text-green-400' : 'bg-amber-500/15 text-amber-300'}>
            {data.passed ? 'Passed' : `Pass mark ${data.pass_mark}`}
          </Badge>}>
      <div className="space-y-4 pt-3">
        <div className="flex items-end gap-2">
          <span className="text-3xl font-bold text-white" data-testid="learner-rubric-total">{data.total_score}</span>
          <span className="text-zinc-500 mb-1">/ {data.total_points} points</span>
        </div>
        <div className="relative">
          <Progress value={pct} className="h-2 bg-zinc-800" />
          <span className="absolute -top-1 h-4 w-0.5 bg-teal-300" style={{ left: `${data.pass_mark}%` }} title="Pass mark" />
        </div>
        <div className="divide-y divide-zinc-800 text-sm">
          {data.items.map((i) => (
            <div key={i.item_id} className="flex items-center justify-between py-2" data-testid={`learner-rubric-item-${i.item_id}`}>
              <span className="text-zinc-300">{i.activity_title || i.label}<span className="block text-xs text-zinc-500">{i.label}</span></span>
              <span className="font-mono text-zinc-200">{i.earned} / {Number(i.points || 0).toFixed(1)}</span>
            </div>
          ))}
        </div>
      </div>
    </InfoPanel>
  );
}
